import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import PlayerChartCards from '../components/PlayerChartCards';
import PlayerHeader from '../components/PlayerHeader';
import PlayerSession from '../components/PlayerSession';
import { getPlayerCard } from '../services/Player';
import Measurement, { configuration } from '../services/Measurement';

const PlayerDashboard = () => {
  const { dates } = configuration;
  const { pathname, search } = useLocation();
  const params = new URLSearchParams(search);
  const initialSession = parseInt(params.get('session'));
  const initialRange = params.get('range');
  const history = useHistory();
  const [playerCard, setPlayerCard] = useState({});
  const [measurements, setMeasurements] = useState([]);
  const [range, setRange] = useState(initialRange !== null ? initialRange : dates.ALL.value);
  const [session, setSession] = useState(isNaN(initialSession) ? 1 : initialSession);
  const { id } = useParams();

  useEffect(() => {
    getPlayerCard(id, session).then((results) => {
      setPlayerCard(results);
    });
  }, [session, setPlayerCard, id, initialSession, search]);

  useEffect(() => {
    Measurement.getMeasurementsList(id, { date_range: range, sessions: session }).then((results) => {
      setMeasurements(results);
    });
  }, [range, session, setMeasurements, id]);

  const toggleSession = (session) => {
    setSession(session);

    history.replace({
      pathname,
      search: `?session=${session}&range=${range}`,
    });
  };

  const toggleRange = (range) => {
    setRange(range);

    history.replace({
      pathname,
      search: `?session=${session}&range=${range}`,
    });
  };

  return (
    <div>
      {playerCard?.player && (
        <>
          <PlayerHeader player={playerCard.player} />

          <PlayerSession sessionData={playerCard.lastSession} toggleCallback={toggleSession} activeSession={session} />

          {playerCard.lastSession.success !== false && (
            <PlayerChartCards
              measurements={measurements}
              range={range}
              rangeCallback={toggleRange}
              activeSessionCallback={toggleSession}
              activeSession={session}
            />
          )}
        </>
      )}
    </div>
  );
};

const withState = connect((state) => {
  const { user, player } = state;

  return {
    user: user,
    isTherapistRole: user.isTherapistRole,
    currentUserId: user.currentUserId,
    specificPlayer: player.specific_player,
  };
});

export default withState(PlayerDashboard);
